/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MapString,
  MeetingResolution,
  SlugConfig,
  SlugMapping,
  SlugUserConfig,
  UserSlugResolution,
  UserSlugResponse,
} from "./data-contracts";
import { FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "firerouter";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Gets info for slug
   *
   * @tags slugs, public
   * @name GetsInfoForSlug
   * @request GET:/v1/resolve/slugs/{userSlug}
   */
  getsInfoForSlug = (
    userSlug: string,
    query?: {
      /** pass tenant subdomain from url for organisational tenant, for personal tenant don't pass anything */
      subdomain?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      UserSlugResolution,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/resolve/slugs/${userSlug}`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getsInfoForSlug */
  getsInfoForSlugPathGetter = (
    userSlug: string,
    query?: {
      /** pass tenant subdomain from url for organisational tenant, for personal tenant don't pass anything */
      subdomain?: string;
    },
  ) => this.getServicePath(`/v1/resolve/slugs/${userSlug}`, query);

  /**
   * @description Gets info for meeting id
   *
   * @tags meeting, public
   * @name GetsInfoForMeetingId
   * @request GET:/v1/resolve/meeting/{meetingId}
   */
  getsInfoForMeetingId = (meetingId: string, params: RequestParams = {}) =>
    this.request<
      MeetingResolution,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/resolve/meeting/${meetingId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getsInfoForMeetingId */
  getsInfoForMeetingIdPathGetter = (meetingId: string) => this.getServicePath(`/v1/resolve/meeting/${meetingId}`);

  /**
   * @description Get slugs for user id
   *
   * @tags slugs
   * @name GetSlugsForUserId
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/slugs
   * @secure
   */
  getSlugsForUserId = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      string,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/slugs`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSlugsForUserId */
  getSlugsForUserIdPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/slugs`);

  /**
   * @description Get slugs
   *
   * @tags slugs
   * @name GetSlugs
   * @request GET:/v1/tenant/{tenantId}/slugs/{userSlug}
   * @secure
   */
  getSlugs = (tenantId: string, userSlug: string, params: RequestParams = {}) =>
    this.request<
      UserSlugResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/slugs/${userSlug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getSlugs */
  getSlugsPathGetter = (tenantId: string, userSlug: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/slugs/${userSlug}`);

  /**
   * @description Creates a slug from provided string. Replaces language-specific characters with their ASCII equivalent. Errors out if slug is already taken.
   *
   * @tags slugs
   * @name UpsertsASlugForAUser
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/slugs/upsert-for-user/{userSlug}
   * @secure
   */
  upsertsASlugForAUser = (tenantId: string, userId: string, userSlug: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/slugs/upsert-for-user/${userSlug}`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for upsertsASlugForAUser */
  upsertsASlugForAUserPathGetter = (tenantId: string, userId: string, userSlug: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/slugs/upsert-for-user/${userSlug}`);

  /**
   * @description Creates a slug from provided string. Replaces language-specific characters with their ASCII equivalent.
   *
   * @tags slugs
   * @name CreatesASlug
   * @request POST:/v1/tenant/{tenantId}/user/{userId}/slugs/{userSlug}
   * @deprecated
   * @secure
   */
  createsASlug = (tenantId: string, userId: string, userSlug: string, params: RequestParams = {}) =>
    this.request<
      string,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/slugs/${userSlug}`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createsASlug */
  createsASlugPathGetter = (tenantId: string, userId: string, userSlug: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/slugs/${userSlug}`);

  /**
   * @description Deletes a slug
   *
   * @tags slugs
   * @name DeletesASlug
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}/slugs/{userSlug}
   * @secure
   */
  deletesASlug = (tenantId: string, userId: string, userSlug: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/slugs/${userSlug}`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deletesASlug */
  deletesASlugPathGetter = (tenantId: string, userId: string, userSlug: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/slugs/${userSlug}`);

  /**
   * @description Sets slug org setting - if end-users can update their own slugs for organization
   *
   * @tags slugs
   * @name UpdateTenantSlugConfigIsUpdatable
   * @request PUT:/v1/tenant/{tenantId}/slugs-config/{slugsEditable}
   * @secure
   */
  updateTenantSlugConfigIsUpdatable = (tenantId: string, slugsEditable: boolean, params: RequestParams = {}) =>
    this.request<
      SlugConfig,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/slugs-config/${slugsEditable}`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateTenantSlugConfigIsUpdatable */
  updateTenantSlugConfigIsUpdatablePathGetter = (tenantId: string, slugsEditable: boolean) =>
    this.getServicePath(`/v1/tenant/${tenantId}/slugs-config/${slugsEditable}`);

  /**
   * @description Gets slug organization setting
   *
   * @tags slugs
   * @name GetTenantSlugConfig
   * @request GET:/v1/tenant/{tenantId}/slugs-config
   * @secure
   */
  getTenantSlugConfig = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SlugConfig,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/slugs-config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTenantSlugConfig */
  getTenantSlugConfigPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/slugs-config`);

  /**
   * @description Deletes slug organization setting
   *
   * @tags slugs
   * @name DeleteTenantSlugConfig
   * @request DELETE:/v1/tenant/{tenantId}/slugs-config
   * @secure
   */
  deleteTenantSlugConfig = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/slugs-config`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteTenantSlugConfig */
  deleteTenantSlugConfigPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/slugs-config`);

  /**
   * @description Sets slug user setting - if end-users can update their own slugs for organization
   *
   * @tags slugs
   * @name UpdateUserSlugConfigIsUpdatable
   * @request PUT:/v1/tenant/{tenantId}/user/{userId}/slugs-config/{slugsEditable}
   * @secure
   */
  updateUserSlugConfigIsUpdatable = (
    tenantId: string,
    userId: string,
    slugsEditable: boolean,
    params: RequestParams = {},
  ) =>
    this.request<
      SlugUserConfig,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/slugs-config/${slugsEditable}`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserSlugConfigIsUpdatable */
  updateUserSlugConfigIsUpdatablePathGetter = (tenantId: string, userId: string, slugsEditable: boolean) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/slugs-config/${slugsEditable}`);

  /**
   * @description Gets slug user setting
   *
   * @tags slugs
   * @name GetUserSlugConfig
   * @request GET:/v1/tenant/{tenantId}/user/{userId}/slugs-config
   * @secure
   */
  getUserSlugConfig = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      SlugUserConfig,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/slugs-config`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserSlugConfig */
  getUserSlugConfigPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/slugs-config`);

  /**
   * @description Deletes slug user setting
   *
   * @tags slugs
   * @name DeleteUserSlugConfig
   * @request DELETE:/v1/tenant/{tenantId}/user/{userId}/slugs-config
   * @secure
   */
  deleteUserSlugConfig = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/user/${userId}/slugs-config`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteUserSlugConfig */
  deleteUserSlugConfigPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/user/${userId}/slugs-config`);

  /**
   * @description Gets a slug mapping by legacy slug
   *
   * @tags slugs_mapping
   * @name GetsASlugMappingByLegacySlug
   * @request GET:/v1/tenant/{tenantId}/slug-mapping-by-legacy/{type}/{legacy}
   */
  getsASlugMappingByLegacySlug = (tenantId: string, type: string, legacy: string, params: RequestParams = {}) =>
    this.request<
      SlugMapping,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/slug-mapping-by-legacy/${type}/${legacy}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getsASlugMappingByLegacySlug */
  getsASlugMappingByLegacySlugPathGetter = (tenantId: string, type: string, legacy: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/slug-mapping-by-legacy/${type}/${legacy}`);

  /**
   * @description Gets a slug mapping by legacy slug
   *
   * @tags slugs_mapping
   * @name GetsASlugMappingByLegacySlug2
   * @request GET:/v1/slug-mapping-by-legacy-by-subdomain/{subdomain}/{type}/{legacy}
   * @originalName getsASlugMappingByLegacySlug
   * @duplicate
   */
  getsASlugMappingByLegacySlug2 = (subdomain: string, type: string, legacy: string, params: RequestParams = {}) =>
    this.request<
      SlugMapping,
      {
        errorCode: string;
        errorMessage: string;
        arguments?: MapString;
        data?: any;
      }
    >({
      path: `/v1/slug-mapping-by-legacy-by-subdomain/${subdomain}/${type}/${legacy}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getsASlugMappingByLegacySlug2 */
  getsASlugMappingByLegacySlug2PathGetter = (subdomain: string, type: string, legacy: string) =>
    this.getServicePath(`/v1/slug-mapping-by-legacy-by-subdomain/${subdomain}/${type}/${legacy}`);

  /**
   * @description Gets a slug mapping by legacy slug
   *
   * @tags slugs_mapping
   * @name GetsASlugMappingByLegacySlug3
   * @request GET:/v1/slug-mapping-by-legacy-id-by-subdomain/{subdomain}/{type}/{legacyId}
   * @originalName getsASlugMappingByLegacySlug
   * @duplicate
   */
  getsASlugMappingByLegacySlug3 = (subdomain: string, type: string, legacyId: string, params: RequestParams = {}) =>
    this.request<
      SlugMapping,
      {
        errorCode: string;
        errorMessage: string;
        arguments?: MapString;
        data?: any;
      }
    >({
      path: `/v1/slug-mapping-by-legacy-id-by-subdomain/${subdomain}/${type}/${legacyId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getsASlugMappingByLegacySlug3 */
  getsASlugMappingByLegacySlug3PathGetter = (subdomain: string, type: string, legacyId: string) =>
    this.getServicePath(`/v1/slug-mapping-by-legacy-id-by-subdomain/${subdomain}/${type}/${legacyId}`);
}
